/**
 * Tiny localStorage snapshot cache for instant page paint (iter 385).
 *
 * Pattern: pages initialize state from the last snapshot (no spinner),
 * then their normal fetch replaces it and writes a fresh snapshot.
 * Same stale-while-revalidate UX the dispatch board (sc_cache_*) and
 * Street Legal kanban (TanStack persister) already have.
 */
const PREFIX = "pc1:";
const MAX_BYTES = 2_500_000; // skip huge payloads (base64 images etc.)

export function readPageCache(key) {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return null;
    return JSON.parse(raw)?.d ?? null;
  } catch {
    return null;
  }
}

export function writePageCache(key, data) {
  try {
    const json = JSON.stringify({ d: data, t: Date.now() });
    if (json.length > MAX_BYTES) return;
    localStorage.setItem(PREFIX + key, json);
  } catch {
    // Quota hit — drop all snapshots and retry once.
    try {
      Object.keys(localStorage)
        .filter((k) => k.startsWith(PREFIX))
        .forEach((k) => localStorage.removeItem(k));
      localStorage.setItem(PREFIX + key, JSON.stringify({ d: data, t: Date.now() }));
    } catch {
      /* give up silently */
    }
  }
}
